import { HookFormSelect, SubmitButton, TextInput } from "../../../hook-form";
import { DevTool } from "@hookform/devtools";
import {
  IHookForm,
  IInitPaymentLinkDirectCardChargeRequest,
  IViewHostedPaymentLink,
} from "../../../interfaces-and-types";

import amexIcon from "../../../assets/icons/card-vendor-icons/amex.png";
import discoverIcon from "../../../assets/icons/card-vendor-icons/discover.png";
import mastercardIcon from "../../../assets/icons/card-vendor-icons/mastercard.png";
import visaIcon from "../../../assets/icons/card-vendor-icons/visa.png";

import { countries } from "../../../constants";
import { IHasExpiryDateHelper, TCardAuthType } from "./DirectCardChargeForm";
import { PinCodeInput } from "../../../components";
import { cardExpiryDateMask, card_numberMask } from "../../../utils";
import { UseFormSetValue } from "react-hook-form";
import { SaleLineItems } from "../SaleLineItems";

export const View = ({
  isActive,
  searchLineItemsText,

  isLineItemQtyInputTempDisabled,
  setValue,
  saleTotal,

  hostedPaymentLink,
  card_auth_type,
  formValues,
  authInputErrorMessage,
  setPinValue,
  // showIFrame,

  control,
  errors,
  handleSubmit,
  register,
}: // direct card charge
IHookForm<IInitPaymentLinkDirectCardChargeRequest & IHasExpiryDateHelper> & {
  isActive: boolean;
  searchLineItemsText: string | null;

  isLineItemQtyInputTempDisabled: boolean;
  setValue: UseFormSetValue<
    IInitPaymentLinkDirectCardChargeRequest & IHasExpiryDateHelper
  >;
  saleTotal: number;
  formValues: IInitPaymentLinkDirectCardChargeRequest & IHasExpiryDateHelper;
  hostedPaymentLink: IViewHostedPaymentLink;
  card_auth_type: null | TCardAuthType;
  authInputErrorMessage: string | null;
  setPinValue: (pin: string) => void;
  // showIFrame: boolean;
}) => {
  const CardIcons = () => {
    return (
      <div className="mr-5">
        <img
          src={mastercardIcon}
          alt="card vendor logo"
          className="card-vendor--logo"
        />
        <img
          src={visaIcon}
          alt="card vendor logo"
          className="card-vendor--logo bordered-icon"
        />
        <img
          src={amexIcon}
          alt="card vendor logo"
          className="card-vendor--logo bordered-icon"
        />
        <img
          src={discoverIcon}
          alt="card vendor logo"
          className="card-vendor--logo bordered-icon"
        />
      </div>
    );
  };

  const showCardAuthInput =
    card_auth_type === "pin" ||
    card_auth_type === "avs_noauth" ||
    card_auth_type === "otp";

  return (
    <div className="direct-card-charge--container">
      <form onSubmit={handleSubmit}>
        {isActive ? (
          <SaleLineItems
            saleTotal={saleTotal}
            isLineItemQtyInputTempDisabled={isLineItemQtyInputTempDisabled}
            hostedPaymentLink={hostedPaymentLink}
            setValue={setValue as any}
            register={register as any}
            errors={errors}
          />
        ) : null}

        {card_auth_type === "pin" ? (
          <PinCodeInput
            title="Enter Card Pin"
            subtitle=""
            buttonText="Enter PIN"
            onChange={setPinValue}
            pin={formValues.card_auth.pin || ""}
            pinCodeLength={4}
            errorMessage={authInputErrorMessage || ""}
            handlePinSubmit={() => {}}
          />
        ) : card_auth_type === "avs_noauth" ? (
          <>
            <HookFormSelect
              name="card_auth.billing_country"
              label="Billing Country"
              selectItems={[]}
              selectGroupedItems={countries}
              register={register}
              errors={errors}
            />

            <TextInput
              name="card_auth.billing_state"
              label="Billing State"
              placeholder="enter billing state"
              type="text"
              register={register}
              errors={errors}
            />

            <TextInput
              name="card_auth.billing_city"
              label="Billing City"
              // placeholder="Expiry Date"
              placeholder="enter billing city"
              type="text"
              register={register}
              errors={errors}
            />

            <TextInput
              name="card_auth.billing_address"
              label="Billing Address"
              placeholder="enter billing address"
              type="text"
              register={register}
              errors={errors}
            />

            <TextInput
              name="card_auth.billing_zip"
              label="Billing Zip"
              // placeholder="Expiry Date"
              placeholder="enter card pin"
              type="text"
              register={register}
              errors={errors}
            />
          </>
        ) : card_auth_type === "otp" ? (
          <TextInput
            name="card_auth.otp"
            label="Enter OTP"
            // placeholder="Expiry Date"
            placeholder="enter OTP"
            helperText="enter OTP sent to mobile phone of card owner"
            type="text"
            register={register}
            errors={errors}
          />
        ) : null}

        <div className={`${!showCardAuthInput ? "d-block" : "d-none"}`}>
          <>
            {hostedPaymentLink.is_temp_payment_link ||
            hostedPaymentLink.is_top_up_payment_link ? null : (
              <TextInput
                name="customer.email"
                label="Email"
                type="text"
                register={register}
                errors={errors}
              />
            )}

            {!hostedPaymentLink.require_customer_full_name ? null : (
              <TextInput
                name="customer.full_name"
                label="Full Name"
                type="text"
                register={register}
                errors={errors}
              />
            )}

            {!hostedPaymentLink.require_customer_address ? null : (
              <TextInput
                name="customer.address"
                label="Address"
                type="text"
                register={register}
                errors={errors}
              />
            )}

            {!hostedPaymentLink.require_customer_phone_number ? null : (
              <TextInput
                name="customer.phone_number"
                label="Phone Number"
                type="text"
                register={register}
                errors={errors}
              />
            )}

            <TextInput
              name="cardholder_name"
              label="Name on card"
              // infoIconText=""
              type="text"
              autoComplete="ccname"
              register={register}
              errors={errors}
            />

            <TextInput
              name="card_number"
              label="Card Details"
              placeholder={
                formValues.card_number ? "Card Number" : "1234 1234 1234 1234"
              }
              type="text"
              autoComplete="cc-number"
              iconRight={<CardIcons />}
              className="card-number"
              onChange={card_numberMask.onChange}
              register={register}
              errors={errors}
              hideErrorMessage
            />

            <div className="flex-container">
              <div className="flex-box">
                <TextInput
                  name="expiryDateHelper"
                  label=""
                  placeholder="MM / YY"
                  type="text"
                  autoComplete="cc-exp"
                  containerClassName="card-input--field"
                  className="card-expiry-date"
                  onChange={cardExpiryDateMask.onChange}
                  register={register}
                  errors={errors}
                />

                {/* <div className="d-none">
                  <TextInput
                    name="expiry_month"
                    label=""
                    placeholder="MM"
                    type="text"
                    autocomplete="cc-exp"
                    containerClassName="card-input--field"
                    className="card-expiry-month"
                    onChange={cardExpiryDateMask.onChange}
                    register={register}
                    errors={errors}
                  />
                  <TextInput
                    name="expiry_year"
                    label=""
                    placeholder="YY"
                    type="text"
                    autocomplete="cc-exp"
                    containerClassName="card-input--field"
                    className="card-expiry-year"
                    onChange={cardExpiryDateMask.onChange}
                    register={register}
                    errors={errors}
                  />
                </div> */}
              </div>

              <div className="flex-box">
                <TextInput
                  name="cvv"
                  label=""
                  placeholder="CVV"
                  // helperText="3 digits on back of your card"
                  infoIconText=""
                  type="text"
                  autoComplete="cc-csc"
                  containerClassName="card-input--field"
                  className="card-cvv"
                  maxLength={3}
                  register={register}
                  errors={errors}
                />
              </div>
            </div>

            <HookFormSelect
              name="country"
              label="Country Or Region"
              infoIconText="The country or region the card was issued in"
              selectItems={[]}
              selectGroupedItems={countries}
              register={register}
              errors={errors}
            />
          </>
        </div>

        <div className="flex-container buttons-container mt-5">
          <SubmitButton className=" onboarding-submit--button">
            {card_auth_type && card_auth_type !== "redirect"
              ? `Submit ${/*card_auth_type.toUpperCase()*/ ""}`
              : hostedPaymentLink.is_top_up_payment_link
              ? "Top-Up"
              : "Pay"}
          </SubmitButton>
        </div>
      </form>
      <DevTool control={control} /> {/* setup hook form dev tool */}
    </div>
  );
};
